<template>
  <div data-testid="talk-to-warren">
    <NavBar>
      <template #left>
        <IconButton
          type="button"
          icon-name="ic_arrow_left"
          @click="goToPreviousStep('disconnectDevices')"
        />
      </template>
      <template #center>
        <span class="navbar-title">Falar com a Warren</span>
      </template>
    </NavBar>
    <div class="content">
      <div class="talk-to-warren">
        <div>
          <Heading :level="2">{{ TalkToWarrenTexts.title }}</Heading>
          <BaseText
            class="subtitle"
            size="lg"
            :color="NebraskaColors.textSecondary"
          >
            {{ TalkToWarrenTexts.subtitle }}
          </BaseText>
        </div>
        <ul class="talk-to-warren--list">
          <li class="talk-to-warren--list--item">
            <div class="talk-to-warren--list--item--icon">
              <BaseIcon
                :icon="TalkToWarrenTexts.email.icon"
                :colors="NebraskaColors.primary"
                width="20"
                height="20"
              />
            </div>
            <div class="talk-to-warren--list--item--content">
              <BaseText
                class="talk-to-warren--list--item--content--title"
                size="lg"
              >
                {{ TalkToWarrenTexts.email.title }}
              </BaseText>
              <BaseText size="md" :color="NebraskaColors.textSecondary">
                {{ TalkToWarrenTexts.email.subtitle }}
              </BaseText>
              <BaseText size="md" :color="NebraskaColors.textSecondary">
                <Link @click="handleEmailClick">
                  {{ TalkToWarrenTexts.email.textLink }}
                </Link>
              </BaseText>
            </div>
          </li>
          <li class="talk-to-warren--list--item">
            <div class="talk-to-warren--list--item--icon">
              <BaseIcon
                :icon="TalkToWarrenTexts.chat.icon"
                :colors="NebraskaColors.primary"
                width="20px"
                height="20px"
              />
            </div>
            <div class="talk-to-warren--list--item--content">
              <BaseText
                class="talk-to-warren--list--item--content--title"
                size="lg"
              >
                {{ TalkToWarrenTexts.chat.title }}
              </BaseText>
              <BaseText size="md" :color="NebraskaColors.textSecondary">
                {{ TalkToWarrenTexts.chat.subtitle }}
              </BaseText>
              <BaseText size="md" :color="NebraskaColors.textSecondary">
                <Link @click="openZendeskChat">
                  {{ TalkToWarrenTexts.chat.textLink }}
                </Link>
              </BaseText>
            </div>
          </li>
          <li class="talk-to-warren--list--item">
            <div class="talk-to-warren--list--item--icon">
              <BaseIcon
                :icon="TalkToWarrenTexts.faq.icon"
                :colors="NebraskaColors.primary"
                width="20px"
                height="20px"
              />
            </div>
            <div class="talk-to-warren--list--item--content">
              <BaseText
                class="talk-to-warren--list--item--content--title"
                size="lg"
              >
                {{ TalkToWarrenTexts.faq.title }}
              </BaseText>
              <BaseText size="md" :color="NebraskaColors.textSecondary">
                <Link @click="goToFaq">
                  {{ TalkToWarrenTexts.faq.textLink }}
                </Link>
                <BaseIcon
                  icon="ic_arrowUp"
                  class="talk-to-warren--list--item--content--icon"
                  :colors="NebraskaColors.primary"
                  width="12"
                  height="12"
                />
              </BaseText>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Vue } from 'vue-property-decorator';
import {
  NavBar,
  IconButton,
  Heading,
  BaseText,
  BaseIcon,
  Link
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { talkToWarrenConstants } from './text-constants';
import * as trackEvents from './track-events';
import { zendeskLoader } from '@/modules/common/services/zendesk/zendesk-loader';

@Component({
  components: {
    NavBar,
    IconButton,
    Heading,
    BaseText,
    BaseIcon,
    Link
  }
})
export default class TalkToWarren extends Vue {
  private NebraskaColors = NebraskaColors;
  private TalkToWarrenTexts = talkToWarrenConstants;

  @Emit('previous-step')
  public goToPreviousStep(step?: string) {
    trackEvents.trackGoBackClick();
    return step;
  }

  mounted() {
    trackEvents.trackTalkToWarrenLoad();
  }

  public handleEmailClick() {
    trackEvents.trackSendEmailClick();
    this.openEmailClient();
  }

  public goToFaq() {
    trackEvents.trackGoFaqClick();
    window.open(this.TalkToWarrenTexts.faq.href, '_blank');
  }

  public async openZendeskChat() {
    trackEvents.trackOpenChatClick();
    try {
      await zendeskLoader.openChat();
    } catch (error) {
      console.error('Erro ao abrir chat:', error);
    }
  }

  private openEmailClient() {
    window.location.href = this.TalkToWarrenTexts.email.href;
  }
}
</script>
<style lang="less" scoped>
.content {
  @navbar-height: 64px;
  min-height: calc(100vh - @navbar-height);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .talk-to-warren {
    max-width: 720px;

    .subtitle {
      margin-top: @size-spacing-x150;
    }

    &--list {
      margin-top: @size-spacing-x800;
      padding: 0;
      width: 100%;

      &--item {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
        margin-bottom: @size-spacing-x800;
        width: 100%;

        &--icon {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 72px;
          min-height: 72px;
          margin-right: @size-spacing-x600;
          border-radius: @size-radius-max;
          background: @theme-secondary;
        }

        &--content {
          max-width: 280px;

          &--title {
            font-weight: 700;
          }

          &--icon {
            margin-left: @size-spacing-x300;
          }
        }
      }
    }
  }
}
</style>
